function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
 * Get uppy instance IDs for which state is stored.
 */
function findUppyInstances() {
  var instances = [];

  for (var i = 0; i < localStorage.length; i++) {
    var key = localStorage.key(i);

    if (/^uppyState:/.test(key)) {
      instances.push(key.slice('uppyState:'.length));
    }
  }

  return instances;
}
/**
 * Try to JSON-parse a string, return null on failure.
 */


function maybeParse(str) {
  try {
    return JSON.parse(str);
  } catch (err) {
    return null;
  }
}

var cleanedUp = false;

var MetaDataStore = /*#__PURE__*/function () {
  function MetaDataStore(opts) {
    _classCallCheck(this, MetaDataStore);

    this.opts = _objectSpread({
      expires: 24 * 60 * 60 * 1000
    }, opts);
    this.name = "uppyState:".concat(opts.storeName);

    if (!cleanedUp) {
      cleanedUp = true;
      MetaDataStore.cleanup();
    }
  }
  /**
   *
   */


  _createClass(MetaDataStore, [{
    key: "load",
    value: function load() {
      var savedState = localStorage.getItem(this.name);
      if (!savedState) return null;
      var data = maybeParse(savedState);
      if (!data) return null; // Upgrade pre-0.20.0 uppyState: it used to be just a flat object,
      // without `expires`.

      if (!data.metadata) {
        this.save(data);
        return data;
      }

      return data.metadata;
    }
  }, {
    key: "save",
    value: function save(metadata) {
      var expires = Date.now() + this.opts.expires;
      var state = JSON.stringify({
        metadata: metadata,
        expires: expires
      });
      localStorage.setItem(this.name, state);
    }
    /**
     * Remove all expired state.
     */

  }], [{
    key: "cleanup",
    value: function cleanup(instanceID) {
      if (instanceID) {
        localStorage.removeItem("uppyState:".concat(instanceID));
        return;
      }

      var instanceIDs = findUppyInstances();
      var now = Date.now();
      instanceIDs.forEach(function (id) {
        var data = localStorage.getItem("uppyState:".concat(id));
        if (!data) return;
        var obj = maybeParse(data);
        if (!obj) return;

        if (obj.expires && obj.expires < now) {
          localStorage.removeItem("uppyState:".concat(id));
        }
      });
    }
  }]);

  return MetaDataStore;
}();

export { MetaDataStore as default };